export const POLICY_LINKS = [
  { label: "이용약관", hash: "policy" },
  { label: "개인정보취급방침", hash: "privacy" },
  { label: "환불정책", hash: "refund" },
  { label: "서비스 제공기간 안내", hash: "service_period" },
];

export const COMPANY_INFO = {
  representative: "이현호",
  address: "서울특별시 성동구 상원6길 8, 비 1층 이72호(성수동1가)",
  salesNumber: "2024-서울성동-1358",
  businessNumber: "770-87-02961",
  email: "hopescience0110@naver.com",
  phone: "010-2952-1960",
  copyright: "Copyrightⓒ희망과학 심리상담센터. All rights reserved.",
};

/** URL이 있을 때만 외부 링크, 없으면 준비 중 모달 */
export const SOCIAL_LINKS = {
  instagram:
    "https://www.instagram.com/hopescience4u?igsh=MXVqZ2cydjI1anUzMQ==",
  youtube: "https://www.youtube.com/@hopescience",
};

export const SOCIAL_UNAVAILABLE_MODAL = {
  title: "안내",
  message: "해당 SNS 서비스는 준비 중입니다.",
};
